var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0H0V16H23.9998V0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 0H11.955V16H24.0017V0Z",
    fill: "#E7E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 5.09961H0V10.9008H23.9998V5.09961Z",
    fill: "#2A2FAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 5.09961H11.955V10.9008H24.0017V5.09961Z",
    fill: "#1318A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0H0V2.52632H23.9998V0Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 0H11.955V2.52632H24.0017V0Z",
    fill: "#C60000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 13.4268H0V15.9999H23.9998V13.4268Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 13.4268H11.955V15.9999H24.0017V13.4268Z",
    fill: "#C60000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThai);
export default __webpack_public_path__ + "static/media/thai.294b2ca79fe7f6c3af0fd0dde07d6d67.svg";
export { ForwardRef as ReactComponent };